export const ValidateNullUndefinedEmpty = (value) => {
    return value !== undefined && value !== null && value !== ""
}